/** 一级菜单图标类名固定为 app-sider-menu-icon，着色由 moduleMenuAccent.less（仅当前模块蓝色）统一控制 */

function MenuIcon({ className }) {
    return <span className={['bi', className, 'app-sider-menu-icon'].join(' ')} aria-hidden="true" />;
}

export const menuItems = [
    {
        key: '/',
        label: '首页',
        icon: <MenuIcon className="bi-house-fill" />,
    },
    {
        key: 'medproject',
        label: '医项目',
        icon: <MenuIcon className="bi-rocket-fill" />,
        children: [{ key: '/medproject/projects', label: '医项目管理' }],
    },
    {
        key: 'invitation',
        label: '医邀请',
        icon: <MenuIcon className="bi-envelope-fill" />,
        children: [{ key: '/invitation/groups', label: '邀请组列表' }],
    },
    {
        key: 'wj',
        label: '医调研',
        icon: <MenuIcon className="bi-journal-text" />,
        children: [
            { key: '/wj/surveys', label: '问卷管理' },
            { key: '/wj/templates', label: '问卷模板' },
            { key: '/wj/questionbank/settings', label: '题库配置' },
        ],
    },
    {
        key: 'conf',
        label: '医会议',
        icon: <MenuIcon className="bi-people-fill" />,
        children: [
            { key: '/conf/conferences', label: '会议项目' },
            { key: '/conf/conferences/labor-progress', label: '项目劳务进度' },
            // { key: '/conf/conferences/usage', label: '应用统计' },
            { key: '/conf/conferences/service-provider', label: '服务商管理' },
        ],
    },
    {
        key: 'selection',
        label: '医评议',
        icon: <MenuIcon className="bi-clipboard-check" />,
        children: [
            { key: '/selection/projects', label: '评议项目' },
            { key: '/selection/cases', label: '实践管理' },
        ],
    },
    {
        key: 'dc',
        label: '数据中心',
        icon: <MenuIcon className="bi-database-fill" />,
        children: [
            {
                key: 'expert-data',
                label: '专家库',
                children: [
                    { key: '/dc/experts', label: '专家管理' },
                    { key: '/dc/experts-evaluation', label: '专家价值' },
                ],
            },
            {
                key: 'dc-organization',
                label: '机构库',
                children: [
                    { key: '/dc/organization/list', label: '机构管理' },
                    { key: '/dc/organization/merge-management', label: '合并机构管理' },
                ],
            },
        ],
    },
    {
        key: 'finance',
        label: '财务中心',
        icon: <MenuIcon className="bi-wallet2" />,
        children: [{ key: '/finance/laborfee/projects', label: '付款项目管理' }],
    },
    {
        key: 'uc',
        label: '用户中心',
        icon: <MenuIcon className="bi-person-circle" />,
        children: [
            { key: '/uc/users', label: '用户管理' },
            { key: '/uc/user-groups', label: '用户分群' },
            {
                key: 'user-data',
                label: '用户数据',
                children: [
                    { key: '/uc/user/overview', label: '用户数据总览' },
                    { key: '/uc/user/active-user', label: '活跃用户统计' },
                    { key: '/uc/user/auth-user-department', label: '医务人员科室分布' },
                ],
            },
            {
                key: 'uc-mdm',
                label: '医疗决策人数据',
                children: [
                    { key: '/uc/mdm/auth-overview', label: '认证总览' },
                    { key: '/uc/mdm/online-overview', label: '在线总览' },
                    { key: '/uc/mdm/projects', label: '参与项目统计' },
                ],
            },
            {
                key: 'consultations-data',
                label: '用户咨询',
                children: [{ key: '/uc/user/consultations', label: '用户咨询列表' }],
            },
        ],
    },
    {
        key: 'operation',
        label: '运营中心',
        icon: <MenuIcon className="bi-bar-chart-fill" />,
        children: [
            {
                key: 'operation-source',
                label: '渠道来源',
                children: [
                    { key: '/operation/channels', label: '渠道管理' },
                    { key: '/operation/channel-cates', label: '渠道分类' },
                ],
            },
            {
                key: 'operation-data',
                label: '渠道数据',
                children: [
                    { key: '/operation/bi/channel/users', label: '渠道用户数据' },
                    { key: '/operation/bi/channel/view', label: '渠道浏览数据' },
                    { key: '/operation/bi/channel/surveys', label: '渠道问卷数据' },
                ],
            },
        ],
    },
    {
        key: 'healthclass',
        label: '健学云',
        icon: <MenuIcon className="bi-mortarboard-fill" />,
        children: [
            { key: '/healthclass/FormalOrganizations', label: '正式学苑管理' },
            { key: '/healthclass/TrialOrganizations', label: '试用学苑管理' },
            { key: '/healthclass/CheckOrganizations', label: '学苑审核管理' },
            { key: '/healthclass/clue', label: '咨询用户' },
        ],
    },
    // {
    //     key: 'kb',
    //     label: '研究型医院',
    //     icon: <MenuIcon className="bi-hospital-fill" />,
    //     children: [
    //         {
    //             key: 'kb-rearch',
    //             label: '研究型医院',
    //             children: [
    //                 { key: '/kb/rearch', label: '数据填报管理' },
    //             ],
    //         },
    //     ],
    // },
    {
        key: 'healthaccount',
        label: '健康号',
        icon: <MenuIcon className="bi-heart-pulse-fill" />,
        children: [
            {
                key: 'eha-enterprises',
                label: '企业健康号',
                children: [
                    { key: '/healthaccount/eha/enterprises', label: '医企+企业管理' },
                    { key: '/healthaccount/eha/solutions', label: '解决方案管理' },
                ],
            },
        ],
    },
    {
        key: 'enterprise',
        label: '企业管理',
        icon: <MenuIcon className="bi-building" />,
        children: [
            {
                key: 'enterprise-staffs',
                label: '企业管理',
                children: [
                    { key: '/enterprise/staffs', label: '员工管理' },
                    { key: '/enterprise/departments', label: '部门管理' },
                ],
            },
            {
                key: 'enterprise-roles',
                label: '系统权限',
                children: [
                    { key: '/enterprise/roles', label: '角色管理' },
                    { key: '/enterprise/permissions', label: '权限管理' },
                ],
            },
            {
                key: 'operation-log',
                label: '系统管理',
                children: [{ key: '/enterprise/operation/log', label: '操作日志' }],
            },
        ],
    },
];

function collectLeafEntries(items) {
    return items.flatMap(item => (item.children ? collectLeafEntries(item.children) : [[item.key, item.label]]));
}

export const pathLabelMap = Object.fromEntries(collectLeafEntries(menuItems));

export const flatMenuItems = menuItems.flatMap(item =>
    item.children
        ? item.children.flatMap(child =>
              child.children ? child.children.flatMap(leaf => (leaf.children ? leaf.children.map(deepLeaf => ({ key: deepLeaf.key, label: deepLeaf.label, groupLabel: item.label })) : [{ key: leaf.key, label: leaf.label, groupLabel: item.label }])) : [{ key: child.key, label: child.label, groupLabel: item.label }],
          )
        : [{ key: item.key, label: item.label, groupLabel: '' }],
);
